import React, { useState, useRef } from "react"
import useOutsideClick from '../../../lib/useOutsideClick';

export default function AddNewPop({ children, title }) {
    const [open, setOpen] = useState(false)
    const wrapperRef = useRef(null);
    useOutsideClick(wrapperRef, () => setOpen(false))
    return (
        <div ref={wrapperRef} className='add-item'>
            <div className='add-pop-up' onClick={() => setOpen(!open)}>
                <img src='/Assets/add-item.svg' className='img-size' alt='Add New Item' />
                <span className='add-text'>{title}</span>
                <img src='/Assets/top-dd.svg' alt='DropDown Symbol' />
            </div>
            {open && (
                <div className='add-pop-show'>
                    {
                        children
                    }
                </div>
            )}
        </div>
    )
}